module.exports = "/_next/static/images/icon-pinterest-cd4b444af7b6d1d12588cf482dab3ea3.svg";